<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="sail-box">
      <div class="title-box">
        <div>Inovasi keuangan, kesejahteraan pertama</div>
        <p>Berfokus pada kesejahteraan sosial dan layanan keuangan, kami berkomitmen untuk menyediakan aktivitas perantara mata uang dan asuransi untuk memberikan lebih banyak kesejahteraan dan keamanan bagi masyarakat Indonesia</p>
      </div>
    </div>

    <div class="business-box">
      <div class="title">Ruang Lingkup Bisnis</div>
      <div class="onlist"></div>
      <div class="sbtitle">Perusahaan menyediakan solusi keuangan yang komprehensif seperti kesejahteraan sosial, jasa keuangan, intermediasi uang dan kegiatan asuransi. </div>
      <div class="item-box">
        <div class="item">
          <img src="../assets/img-1.png" alt="">
          <div class="text">Kesejahteraan Sosial</div>
        </div>

        <div class="item">
          <img src="../assets/img-2.png" alt="">
          <div class="text">Layanan Keuangan</div>
        </div>

        <div class="item">
          <img src="../assets/img-3.png" alt="">
          <div class="text">kegiatan asuransi</div>
        </div>
      </div>
    </div>

    <div class="number-box">
      <div class="number-text">
        <div class="title">Prestasi perusahaan</div>
        <div class="sbtitle">KOPERASI SIMPAN PINJAM TABUNGAN BERGUNA GEMILANG telah berhasil mencapai prestasi yang signifikan di bidang kesejahteraan sosial, jasa keuangan dan kegiatan asuransi.Melalui layanan perantara moneter yang inovatif, telah memberikan dukungan ekonomi dan keamanan yang dapat diandalkan kepada anggota masyarakat, sangat meningkatkan kesejahteraan ekonomi dan kesejahteraan masyarakat setempat, inklusi keuangan</div>

      </div>
      <div class="num-box">
        <div class="item">
          <div class="number">Inovasi Keuangan</div>
          <div class="name">Mempromosikan pengembangan perantara moneter.</div>
        </div>
        <div class="item">
          <div class="number">Kontribusi Sosial</div>
          <div class="name">Meningkatkan kesejahteraan masyarakat.</div>
        </div>
        <div class="item">
          <div class="number">layanan asuransi</div>
          <div class="name">Meningkatkan keamanan ekonomi.</div>
        </div>
      </div>
    </div>

    <div class="say-box">
      <div class="title">Apa yang dikatakan pengguna kami?</div>
      <div class="onlin"></div>
      <div class="list-box">
        <div class="item">
          <img src="../assets/img-4.png" alt="">
          <div class="text-2"> Dukungan finansial Anda telah mengubah hidup saya dan memberi saya dan keluarga masa depan yang lebih baik. Melalui layanan pinjaman preferensial komunitas, saya dapat memulai usaha kecil-kecilan saya sendiri dan menstabilkan keuangan keluarga saya. </div>
          <div class="name-info">
            <img src="../assets/img-5.png" alt="">
            <div class="neme">
              <div>Andar</div>
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/img-4.png" alt="">
          <div class="text-2"> Sebagai perantara uang, saya sangat terbantu oleh perusahaan, dan layanan keuangan serta konsultasi yang diberikannya telah sangat mengoptimalkan proses bisnis saya, meningkatkan efisiensi dan profitabilitas. </div>
          <div class="name-info">
            <img src="../assets/img-6.png" alt="">
            <div class="neme">
              <div>Sahara</div>
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/img-4.png" alt="">
          <div class="text-2"> Sebagai penerima manfaat asuransi, saya bersyukur atas layanan asuransi yang diberikan oleh TABUNGAN BERGUNA GEMILANG yang memberikan dukungan finansial ketika saya mengalami gangguan kesehatan, meringankan beban finansial saya dan keluarga, serta memberikan ketenangan dan rasa aman. </div>
          <div class="name-info">
            <img src="../assets/img-7.png" alt="">
            <div class="neme">
              <div>Ira</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pattom"></div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>


<style lang="less" scoped>
.sail-box {
  width: 100%;
  height: 993px;
  background-image: url(../assets/bg.png);
  background-size: 100% 100%;
  margin-top: -1px;
  display: flex;
  flex-direction: column;
  // align-items: center;
  justify-content: center;

  color: #FFFFFF;

  .title-box {
    margin-left: 256px;
    width: 662px;

    div {
      font-size: 50px;
      font-weight: bold;
    }

    p {
      margin-top: 43px;
      font-size: 16px;
    }
  }
}

.business-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 129px;

  .title {
    font-size: 50px;
    font-weight: bold;
    color: #333333;
  }

  .onlist {
    width: 150px;
    height: 3px;
    background: #0050FF;
    margin-top: 24px;
  }

  .sbtitle {
    width: 472px;
    font-size: 14px;
    color: #737373;
    margin-top: 16px;
  }

  .item-box {
    width: 1203px;
    padding: 84px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .item {
      width: 181px;
      height: 205px;
      background: #FFFFFF;
      box-shadow: 0px 5px 32px 0px rgba(93, 112, 223, 0.1);
      border-radius: 10px;
      padding: 50px 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      img {
        width: 100px;
      }

      .text {
        font-size: 24px;
        color: #051B1D;
        margin-top: 28px;
      }
    }
  }
}

.number-box {
  height: 510px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .number-text {
    width: 100%;
    height: 400px;
    background: #1F65FF;
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-size: 50px;
      margin-top: 77px;
    }

    .sbtitle {
      color: #FFFFFF;
      width: 790px;
      margin-top: 27px;
      padding-bottom: 120px;
      text-align: center;
    }

  }

  .num-box {
    width: 1170px;
    height: 240px;
    background: #FFFFFF;
    box-shadow: 0px 3px 16px 0px rgba(128, 83, 254, 0.1);
    border-radius: 10px;
    margin-top: -120px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .number {
      font-size: 20px;
      color: #1F65FF;
      font-weight: bold;
    }

    .name {
      font-size: 16px;
      color: #243668;
      margin-top: 18px;
      width: 300px;
    }
  }
}

.say-box {
  padding: 170px 350px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    font-size: 50px;
    color: #021744;
  }

  .onlin {
    width: 150px;
    height: 3px;
    background: #0050FF;
    margin-top: 25px;
  }

  .list-box {
    margin-top: 85px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;

    .item {
      width: 322px;
      height: 350px;
      background: #F5F8FF;
      border-radius: 30px;
      padding: 50px 30px;
      text-align: left;

      img {
        width: 70px;
      }

      .text-2 {
        margin-top: 50px;
        min-height: 180px;
      }

      .name-info {
        display: flex;
        align-items: center;
        // justify-content: center;

        img {
          width: 60px;
          margin-right: 15px;
        }

        .neme {
          div {
            font-size: 24px;
            color: rgba(5, 27, 29, 0.7);
          }

          p {
            font-size: 20px;
            color: rgba(5, 27, 29, 0.7);
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>
